import config from './config';
import pkg from '../../package.json';

let browserLng = navigator.language;
if (browserLng === 'fr') {
  browserLng = 'fr-FR';
} else if (browserLng === 'de') {
  browserLng = 'de-DE';
}

const localeConfig = {
  defaultLanguage: browserLng,
  defaultNS: pkg.translations.namespaces[0],
  ns: pkg.translations.namespaces,
  localesCdn: config.localesCdn,
};

export default localeConfig;
